import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateCompanyPartnerTypes = async (companyId, partnerTypes) => {
  return axios.put(
    `/api/companies/${companyId}/partner_types`,
    JSON.stringify({ partner_types: partnerTypes })
  );
};

export const useUpdateCompanyPartnerTypes = (companyId) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (partnerTypes) => updateCompanyPartnerTypes(companyId, partnerTypes),
    onSuccess: () => {
      enqueueSnackbar('Partner was successfully updated', { variant: 'success' });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
